import { Employee } from './employee';
import { Device } from '.';
import { ModelBase } from '../common/contracts/base.model';
export class TimeLogs extends ModelBase {
  type: string;
  time: Date;
  device: Device;
  ipAddress: string;
  source: string;
  isComputed: boolean;
  ignore: boolean;
  remarks: string;
  location: TimeLogsLocation = new TimeLogsLocation();
  employee: Employee = new Employee();
}

export class TimeLogsLocation {
  coordinates: number[] = [];
  has = false;
  show = false;
  address = '';
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/time-logs.ts